import { render, staticRenderFns } from "./autoMatchOrder.vue?vue&type=template&id=fb2b38b8&scoped=true"
import script from "./autoMatchOrder.vue?vue&type=script&lang=js"
export * from "./autoMatchOrder.vue?vue&type=script&lang=js"
import style0 from "./autoMatchOrder.vue?vue&type=style&index=0&id=fb2b38b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2b38b8",
  null
  
)

export default component.exports